'use strict';
/*--------------------------------------------------------------------------*
* スムーススクロール
*--------------------------------------------------------------------------*/
var headerHeight = $('header').outerHeight();
var urlHash = location.hash;
if(urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
        var target = $(urlHash);
        var position = target.offset().top - headerHeight - 30;
        $('body,html').stop().animate({scrollTop:position}, 500);
    }, 100);
}
$('a[href^="#"]').on('click',function() {
    var href= $(this).attr('href');
    var target = $(href);
    var position = target.offset().top - headerHeight - 30;
    $('body,html').stop().animate({scrollTop:position}, 500);   
});

/*--------------------------------------------------------------------------*
* アニメーション
*--------------------------------------------------------------------------*/
$(window).on('load scroll', function (){
    var box = $('.fadein');
    var animated = 'active';
    box.each(function(){
        var boxOffset = $(this).offset().top;
        var scrollPos = $(window).scrollTop();
        var wh = $(window).height();
        //画面内のどの位置で処理を実行するかで「100」の値を変更
        if(scrollPos > boxOffset - wh + 100 ){
        $(this).addClass(animated);
        }
    });
});

$(window).on('load scroll', function (){
    var box = $('.fade');
    var animated = 'active';
    box.each(function(){
        var boxOffset = $(this).offset().top;
        var scrollPos = $(window).scrollTop();
        var wh = $(window).height();
        //画面内のどの位置で処理を実行するかで「100」の値を変更
        if(scrollPos > boxOffset - wh + 100 ){
        $(this).addClass(animated);
        }
    });
});

$(window).on('load scroll', function (){
    var box = $('.ivelm');
    var animated = 'show';
    box.each(function(){
      var boxOffset = $(this).offset().top;
      var scrollPos = $(window).scrollTop();
      var wh = $(window).height();
      //画面内のどの位置で処理を実行するかで「100」の値を変更
      if(scrollPos > boxOffset - wh + 100 ){
        $(this).addClass(animated);
      }
    });
});

$(window).on('load scroll', function (){
    var box = $('.blur');
    var animated = 'show';
    box.each(function(){
      var boxOffset = $(this).offset().top;
      var scrollPos = $(window).scrollTop();
      var wh = $(window).height();
      //画面内のどの位置で処理を実行するかで「100」の値を変更
      if(scrollPos > boxOffset - wh + 100 ){
        $(this).addClass(animated);
      }
    });
});
